var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstantAppStatusBarSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 311,
    height: 12,
    rx: 6,
    fill: "#604DBC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 17.366,
    height: 12,
    rx: 6,
    transform: "matrix(-1 0 0 1 204.465 0)",
    fill: "#604DBC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 6,
    height: 6,
    rx: 3,
    stroke: "#fff",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 3,
    width: 6,
    height: 6,
    rx: 3,
    stroke: "#fff",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 302,
    y: 3,
    width: 6,
    height: 6,
    rx: 3,
    stroke: "#fff",
    strokeWidth: 2
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzExIiBoZWlnaHQ9IjEyIiB2aWV3Qm94PSIwIDAgMzExIDEyIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB3aWR0aD0iMzExIiBoZWlnaHQ9IjEyIiByeD0iNiIgZmlsbD0iIzYwNERCQyIvPgo8cmVjdCB3aWR0aD0iMTcuMzY1NiIgaGVpZ2h0PSIxMiIgcng9IjYiIHRyYW5zZm9ybT0ibWF0cml4KC0xIDAgMCAxIDIwNC40NjUgMCkiIGZpbGw9IiM2MDREQkMiLz4KPHJlY3QgeD0iMyIgeT0iMyIgd2lkdGg9IjYiIGhlaWdodD0iNiIgcng9IjMiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8cmVjdCB4PSIxNTMiIHk9IjMiIHdpZHRoPSI2IiBoZWlnaHQ9IjYiIHJ4PSIzIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiLz4KPHJlY3QgeD0iMzAyIiB5PSIzIiB3aWR0aD0iNiIgaGVpZ2h0PSI2IiByeD0iMyIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=";
export { SvgInstantAppStatusBarSuccess as ReactComponent };